module.exports = __webpack_public_path__ + "fonts/NespressoLucas-XtraBdItalic.eot?v=af55b55cd2676bf786e10dff608590c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-XtraBdItalic.eot?
// module id = 685
// module chunks = 0